module.exports = __webpack_public_path__ + "12cc66a94b5577663093af50bc5756fc.jpg";